module.exports = __webpack_public_path__ + "static/media/dashboard_blue.ab50e595.svg";